import gql from 'graphql-tag';

export const queryData = gql`
   query DATA {
      presentaciones {
         codigo
         denominacion
      }
      productos {
         codigo
         denominacion
      }
      versiones {
         codigo
         denominacion
      }
      modulares {
         codigo
         codigoProducto
         denominacion
      }
   }
`;

export const queryDataVer = gql`
   query DATA($codigoProducto: String) {
      productoDetallesOrdDesFechaCreacion(codigoProducto: $codigoProducto) {
         version {
            codigo
            denominacion
         }
         presentacion {
            codigo
            denominacion
         }
      }
   }
`;
export const queryDataPre = gql`
   query DATA($codigoProducto: String, $codVer: String) {
      productoDetallesFiltro(codigoProducto: $codigoProducto, codigoVersion: $codVer) {
         presentacion {
            codigo
            denominacion
         }
      }
   }
`;

export const queryGrupoCliente = gql`
   query grupoCliente($codigoCliente: String!) {
      maxGrupoCliente(codigo: $codigoCliente) {
         grupo
      }
   }
`;
export const mutationGenerarLicencia = gql`
   mutation GenerarLicencias(
      $ruc: String!
      $razonsocial: String!
      $tipoDoc: String!
      $serieDoc: String!
      $nroDoc: String!
      $usuario: String!
      $activaciones: [GenerarLicenciaInput]!
   ) {
      generarLicencia(
         ruc: $ruc
         razonsocial: $razonsocial
         tipoDoc: $tipoDoc
         serieDoc: $serieDoc
         nroDoc: $nroDoc
         usuario: $usuario
         activaciones: $activaciones
      ) {
         msg
      }
   }
`;
